let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cGAab")).then(() => parcelRequire('c2Ip8'));